import { bankConnectionSchema, type BankConnection } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';

const postDisconnect = (): Promise<unknown> =>
  apiRequest<unknown>('/bank/connection/disconnect', { method: 'POST' });

export const disconnectBank = async (): Promise<BankConnection> =>
  bankConnectionSchema.parse(await postDisconnect());
